export default __webpack_public_path__ + "static/media/Michelle-Asuamah-Resume-22.dfc377e0.pdf";